import { Stack, Chip, Tooltip, Box } from '@mui/material';
import { Color } from 'utils/color-helper';

type TagInfo = {
  id: number;
  name: string;
  color: string;
};

type EntityTagsProps = {
  tags?: TagInfo[];
  displayLimit?: number;
};

export const EntityTags = ({ tags = [], displayLimit = 2 }: EntityTagsProps) => {
  const visibleTags = tags.slice(0, displayLimit);
  const hiddenTags = tags.slice(displayLimit);

  const renderChip = (tag: TagInfo, fullTitle: boolean = false) => (
    <Chip
      key={tag.id}
      label={tag.name.length > 10 && !fullTitle? tag.name.slice(0, 10) + '…' : tag.name}
      size="small"
      sx={{
        fontSize: '12px',
        height: 20,
        backgroundColor: tag.color,
        color: Color.fromHex(tag.color).contrast().toHex()
      }}
    />
  );

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      {visibleTags.map(el => renderChip(el))}

      {hiddenTags.length > 0 && (
        <Tooltip
          title={
            <Box display="flex" flexWrap="wrap" gap={0.5}>
              {hiddenTags.map(el => renderChip(el, true))}
            </Box>
          }
          placement="top"
        >
          <Chip
            size="small"
            label={`+${hiddenTags.length}`}
            sx={{ fontSize: '12px', height: 20, cursor: 'help' }}
          />
        </Tooltip>
      )}
    </Stack>
  );
};
